import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CoverConfig } from './types';

@Injectable({
  providedIn: 'root',
})
export class PhotographerCoverServiceService {
  constructor() {}

  getCover(context: string, contextId: string): Observable<CoverConfig> {
    return of({
      file: null,
      point: { x: 50, y: 50 },
      size: { h: null, w: null },
    });
  }
}
